interface Props {
  projeto: {
    tipo: string;
    municipio: string;
    uf: string;
    cliente: string;
    metodologia: string;
    areaAbrangencia: string;
    status: string;
    dataInicio: string;
    dataPrevisao: string;
    dataConclusao?: string;
  };
}

export default function ProjectSettingsPanel({ projeto }: Props) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Dados Gerais */}
      <div className="bg-white rounded-card border border-background-200 p-5">
        <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Dados Gerais do Projeto</h4>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Nome do Projeto</label>
            <input
              type="text"
              defaultValue="Implantação do CTA — Goiânia Centro"
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
              readOnly
            />
          </div>
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Tipo de Projeto</label>
            <input
              type="text"
              defaultValue={projeto.tipo}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
              readOnly
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-foreground-500 font-medium mb-1 block">Município</label>
              <input
                type="text"
                defaultValue={projeto.municipio}
                className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
                readOnly
              />
            </div>
            <div>
              <label className="text-xs text-foreground-500 font-medium mb-1 block">UF</label>
              <input
                type="text"
                defaultValue={projeto.uf}
                className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
                readOnly
              />
            </div>
          </div>
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Cliente / Contratante</label>
            <input
              type="text"
              defaultValue={projeto.cliente}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
              readOnly
            />
          </div>
        </div>
      </div>

      {/* Metodologia e Critérios */}
      <div className="bg-white rounded-card border border-background-200 p-5">
        <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Metodologia e Critérios</h4>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Metodologia</label>
            <input
              type="text"
              defaultValue={projeto.metodologia}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
              readOnly
            />
          </div>
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Área de Abrangência</label>
            <input
              type="text"
              defaultValue={projeto.areaAbrangencia}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
              readOnly
            />
          </div>
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Critérios de Inclusão</label>
            <div className="px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-600">
              DAP &ge; 10 cm · Altura &ge; 2,0 m · Área pública e privada acessível · Vias e calçadas · Praças e parques
            </div>
          </div>
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Status do Projeto</label>
            <input
              type="text"
              defaultValue={projeto.status === "em campo" ? "Em Campo" : projeto.status}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
              readOnly
            />
          </div>
        </div>
      </div>

      {/* Datas */}
      <div className="bg-white rounded-card border border-background-200 p-5">
        <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Datas do Projeto</h4>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Data de Início</label>
            <input
              type="text"
              defaultValue={new Date(projeto.dataInicio).toLocaleDateString("pt-BR")}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
              readOnly
            />
          </div>
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Previsão de Conclusão</label>
            <input
              type="text"
              defaultValue={new Date(projeto.dataPrevisao).toLocaleDateString("pt-BR")}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
              readOnly
            />
          </div>
          <div>
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Data de Conclusão</label>
            <input
              type="text"
              defaultValue={projeto.dataConclusao ? new Date(projeto.dataConclusao).toLocaleDateString("pt-BR") : "—"}
              className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400"
              readOnly
            />
          </div>
          <div className="pt-2 border-t border-background-200">
            <label className="text-xs text-foreground-500 font-medium mb-1 block">Progresso</label>
            <div className="flex items-center gap-3">
              <div className="flex-1 h-2 rounded-full bg-background-200 overflow-hidden">
                <div className="h-full rounded-full bg-primary-500" style={{ width: "45%" }}></div>
              </div>
              <span className="text-sm font-bold text-foreground-900 font-heading tabular-nums">45%</span>
            </div>
          </div>
        </div>
      </div>

      {/* Permissões */}
      <div className="bg-white rounded-card border border-background-200 p-5">
        <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Permissões de Acesso</h4>
        <div className="space-y-2.5">
          {[
            { label: "Visualizar projeto", enabled: true },
            { label: "Editar dados do projeto", enabled: true },
            { label: "Cadastrar árvores", enabled: true },
            { label: "Realizar vistorias", enabled: true },
            { label: "Anexar documentos", enabled: true },
            { label: "Gerar relatórios", enabled: true },
            { label: "Gerenciar equipe", enabled: false },
            { label: "Alterar configurações", enabled: false },
          ].map((perm) => (
            <div key={perm.label} className="flex items-center justify-between py-2 px-3 rounded-lg bg-background-50">
              <span className="text-sm text-foreground-700">{perm.label}</span>
              <span className={`badge text-[10px] ${perm.enabled ? "bg-primary-100 text-primary-700" : "bg-background-200 text-foreground-400"}`}>
                {perm.enabled ? "Habilitado" : "Restrito"}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}